import { Injectable, signal } from '@angular/core';

/** Elements marked with appGuideAnchor, keyed by that id. */
@Injectable({ providedIn: 'root' })
export class GuideAnchors {
  private readonly anchors = new Map<string, HTMLElement>();
  /** Bumps when an anchor is added or removed so a waiting step can look again. */
  readonly version = signal(0);

  register(id: string, element: HTMLElement): void {
    this.anchors.set(id, element);
    this.version.update((value) => value + 1);
  }

  unregister(id: string, element: HTMLElement): void {
    if (this.anchors.get(id) === element) {
      this.anchors.delete(id);
      this.version.update((value) => value + 1);
    }
  }

  get(id: string): HTMLElement | undefined {
    const element = this.anchors.get(id);
    if (!element || !element.isConnected) {
      return undefined;
    }
    return element;
  }
}
